<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .custom-name-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1 0 0;
    width: 100%;

    .input-wrapper {
      display: flex;
      align-items: center;
      gap: utils.in_rem(8px);

      .mandatory-text {
        @include mixins.body2();
        @include colors.color(textBlack);
      }
    }
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import TextInput from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/TextInput.svelte";
  import { showToast } from "@sourcewhale/shared/src/assets/js/src/general/utils";
  import {
    teamNotetakerSettingsStore,
    teamStore,
  } from "../../../../api-stores/meetings-store";
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import { customizeNotetakerBot } from "../../../../api/notetaker";
  import { ToastError } from "@sourcewhale/shared/src/svelte/api/sw-toast-error";

  $: value = $teamNotetakerSettingsStore?.customBotName || "";

  $: placeholder = $userStore?.teamName || "";

  const onclick = async () => {
    try {
      await customizeNotetakerBot({
        kind: "customizeName",
        customBotName: value,
      });
      showToast({ type: "success", title: "Saved" });
    } catch (error) {
      if (error instanceof ToastError) {
        showToast(error);
        return;
      }
      throw error;
    } finally {
      teamStore.get();
    }
  };
</script>

<div class="custom-name-wrapper">
  <div class="input-wrapper">
    <TextInput size="large" kind="input" {placeholder} bind:value />
    <span class="mandatory-text">Notetaker</span>
  </div>
  <Button kind="secondary" size="large" {onclick} style="width: 110px"
    >Save</Button
  >
</div>
